import { FC } from 'react'

import styled from 'styled-components'

import { useCustomSearchParams } from 'src/Hooks/useCustomSearchParams'
import { ModalType, ScheduleSteps } from 'src/Types/ui'
import { PrimaryDottedButton } from 'src/Components/Buttons/PrimaryDottedButton'
import { AddParameterButton } from 'src/Components/Buttons/AddParameterButton'
import { SpotifyCampaignTrackFile } from 'src/Redux/spotifyCampaignStatusApi'

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  align-self: stretch;
`
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  flex: 1 0 0;
  min-width: 0;
`
const SubTitle = styled.div`
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
`
const FileName = styled(SubTitle)`
  font-weight: 400;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

interface SpotifyScheduleTrackFileProps {
  trackFile: SpotifyCampaignTrackFile | null
}

export const SpotifyScheduleTrackFile: FC<SpotifyScheduleTrackFileProps> = ({
  trackFile,
}) => {
  const { setSearch } = useCustomSearchParams()

  const handleClick = (): void => {
    setSearch({ step: ScheduleSteps.SETTINGS, modal: ModalType.TrackFile })
  }

  if (!trackFile) {
    return (
      <AddParameterButton onClick={handleClick}>
        Add track file
      </AddParameterButton>
    )
  }

  return (
    <Container>
      <Wrapper>
        <SubTitle>Track file</SubTitle>
        <FileName title={trackFile.name}>{trackFile.name}</FileName>
      </Wrapper>
      <PrimaryDottedButton onClick={handleClick}>Edit</PrimaryDottedButton>
    </Container>
  )
}
